import { compose } from 'recompose';
import { DemoAthleteOptionsMutation } from '../../../clientState/demoAthlete/queries';
import {
    AthleteOptions,
    AthleteProps,
    SaveAthleteOptionsProps
} from '../types';
import { withSaveAthleteOptionsCore } from '../withSaveAthleteOptions';
import { fetchDemoScalarStreams } from './withDemoActivityStreams';
import { withDemoAthlete } from './withDemoAthlete';

/** Get a payload of the demo athlete, for optimistic loading */
const getDemoAthleteOptionsPayload = (
    id: string,
    athleteOptions: AthleteOptions
): {} => ({
    __typename: 'Mutation',
    demoAthleteOptions: {
        __typename: 'DemoAthleteOptionsPayload',
        demoAthlete: {
            __typename: 'DemoAthlete',
            id: id + '',
            ...athleteOptions
        }
    }
});

/** Allows the demo athlete to be edited */
export const withDemoSaveAthleteOptions = compose<
    AthleteProps & SaveAthleteOptionsProps,
    any
>(
    withDemoAthlete,
    withSaveAthleteOptionsCore(
        DemoAthleteOptionsMutation,
        getDemoAthleteOptionsPayload,
        fetchDemoScalarStreams
    )
);



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/withDemoSaveAthleteOptions.tsx